import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    const { setUser } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data.user);
            const from = loc.state?.from?.pathname;
            // Post-login routing priority:
            // 1. The page the user was trying to reach before being redirected to /login
            // 2. Their team page if they have one assigned (best UX for presidenti)
            // 3. Admin panel for admins without a team
            // 4. Home for everyone else
            let defaultDest = "/";
            if (data.user?.team_id) {
                defaultDest = `/squadre/${data.user.team_id}`;
            } else if (data.user?.role === "admin") {
                defaultDest = "/admin";
            }
            nav(from || defaultDest, { replace: true });
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div
            className="min-h-[80vh] flex items-center justify-center px-4 py-12"
            data-testid="login-page"
        >
            <div className="w-full max-w-md op-card p-8 op-fade-up">
                <div className="op-label text-t2bb6ff">// LOGIN</div>
                <h1 className="op-heading text-4xl mt-3">Bentornato</h1>
                <p className="text-t8f95a3 mt-2 text-sm">
                    Accedi per gestire la tua squadra o l'intero torneo.
                </p>

                <form className="mt-7 space-y-4" onSubmit={onSubmit}>
                    <div>
                        <label className="op-label block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="op-input"
                            placeholder="presidente@example.com"
                            data-testid="login-email-input"
                        />
                    </div>
                    <div>
                        <label className="op-label block mb-2">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="op-input"
                            placeholder="••••••••"
                            data-testid="login-password-input"
                        />
                    </div>
                    {err && (
                        <div
                            className="border border-tff3b30 bg-tff3b30/10 text-tff3b30 text-sm p-3"
                            data-testid="login-error"
                        >
                            {err}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={busy}
                        className="op-btn op-btn-primary w-full"
                        data-testid="login-submit-btn"
                    >
                        {busy ? "Accesso in corso…" : "Accedi"}
                    </button>
                </form>

                <div className="mt-6 text-center text-sm text-t8f95a3">
                    Non hai un account?{" "}
                    <Link to="/signup" className="text-t2bb6ff hover:underline" data-testid="login-to-signup">
                        Iscriviti
                    </Link>
                </div>
            </div>
        </div>
    );
}
